import { useCallback } from "react";

import { createStorage } from "..";

interface IFiltersStorage {
  getValues: (tableName: string, groupName?: string) => unknown;
  setValues: (
    tableName: string,
    values: unknown,
    groupName?: string,
  ) => Promise<boolean>;
}

const filtersStorage = createStorage({
  prefix: "table_filters_",
  type: "local",
});

const storageKey = (tableName: string, groupName?: string): string =>
  groupName === undefined ? tableName : `${tableName}_${groupName}`;

const useFiltersStorage = (): IFiltersStorage => {
  const setValues = useCallback(
    async (
      tableName: string,
      values: unknown,
      groupName?: string,
    ): Promise<boolean> => {
      const key = storageKey(tableName, groupName);

      return filtersStorage.setItem(key, values);
    },
    [],
  );

  const getValues = useCallback(
    (tableName: string, groupName?: string): unknown => {
      const key = storageKey(tableName, groupName);

      return filtersStorage.getItem(key);
    },
    [],
  );

  return { getValues, setValues };
};

export { filtersStorage, useFiltersStorage };
